import React, { useContext } from "react";
import style from "./index.module.scss";
import { Empty, Spin } from "antd";
import {
    filterData,
    queryRule,
    QueryRuleResult
} from "../../../../API/scoreRule";
import TableHeadTip from "../../Components/TableHeadTip";
import ListItem from "./Components/ListItem";
import useRequest from "Utils/useRequest";
import { ScoreContext } from "../../Components/CourseScoreProvider/context";
import Config from "../../../../config";
import { Link } from "react-router-dom";
import AddSc from "../../PageCourseScore/Components/AddSc";
import FileItem from "../../../../components/FileItem";

const Index = () => {
    const { courseNo, courseSeq, weekTimeId } = useContext(ScoreContext);

    const [scoreInfo, { loading }] = useRequest<QueryRuleResult>(
        () => queryRule({ courseNo, courseSeq }),
        { silence: true },
        [courseNo, courseSeq]
    );

    if (scoreInfo?.visible !== "1") {
        return (
            <Empty
                imageStyle={{ height: 220 }}
                style={{ height: 500 }}
                description="任课教师暂未开放查看权限，请耐心等待">
                <div className={style.description}>
                    <span className={style.descText}>更多成绩信息，请点击</span>
                    <Link
                        to={`/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`}
                        className={style.toLink}>
                        学习报告
                    </Link>
                </div>
            </Empty>
        );
    }

    return (
        <div className={style.root}>
            <Spin spinning={false}>
                <div className={style.table}>
                    {scoreInfo?.filePath && (
                        <a
                            target="_blank"
                            href={`${Config.QiNiuDownloadUrl}/${scoreInfo.filePath}`}
                            rel="noreferrer">
                            <FileItem
                                text={scoreInfo.fileName}
                                fileType={scoreInfo?.fileType || ""}
                            />
                        </a>
                    )}
                </div>
                <div className={style.table}>
                    <TableHeadTip title="考试规则" />
                    <Spin spinning={loading}>
                        <div className={style.desp}>
                            {scoreInfo?.description
                                ? scoreInfo?.description
                                : "无"}
                        </div>
                    </Spin>
                </div>
                <div className={style.table}>
                    <TableHeadTip
                        title="平时成绩"
                        percent={scoreInfo?.dailyGrade || 0}
                    />
                    <Spin spinning={loading}>
                        {filterData(scoreInfo?.dailyGradeRuleModel || [])?.map(
                            item => (
                                <ListItem item={item} key={item.id} />
                            )
                        )}
                        {!filterData(scoreInfo?.dailyGradeRuleModel || [])
                            .length && <div className={style.desp}>无</div>}
                    </Spin>
                </div>
                <div style={{ marginTop: 20 }} />
                <div className={style.table}>
                    <TableHeadTip
                        title="期末成绩"
                        percent={scoreInfo?.finalGrade || 0}
                    />
                    <Spin spinning={loading}>
                        {filterData(scoreInfo?.finalGradeRuleModel || [])?.map(
                            item => (
                                <ListItem item={item} key={item.id} />
                            )
                        )}

                        {!filterData(scoreInfo?.finalGradeRuleModel || [])
                            .length && <div className={style.desp}>无</div>}
                    </Spin>
                </div>
                <div className={style.table}>
                    <TableHeadTip title="额外加分" />
                    <div style={{ padding: "35px" }}>
                        {!scoreInfo?.extraRule && (
                            <Empty description="此课程未设置额外加分" />
                        )}
                        {scoreInfo?.extraRule && (
                            <AddSc
                                disabled
                                extraRule={scoreInfo.extraRule}
                                expSwitch
                            />
                        )}
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default Index;
